import { useEffect, useState } from "react";
import localeEvent, { getLang } from "./events";
export default function useLocale() {
    var _a = useState(getLang()), language = _a[0], setLanguage = _a[1];
    useEffect(function () {
        localeEvent.listen(function (e) {
            setLanguage(e.detail.language);
        });
        return function () { return localeEvent.remove(); };
    }, []);
    return {
        language: language,
    };
}
